import * as _ from 'lodash';
import { tzlib_get_ical_block } from 'timezones-ical-library';

import type { ReturnResult } from '../../ics';
import { convertTimestampToArray, createEvents } from '../../ics';
import calendarUtils from '../../utils/calendarUtils';
import clientUtils from '../../utils/clientUtils';
import { compressionUtils } from '../../utils/compressionUtils';
import type { EventForm } from './EventForm';

export const toIcsString = (events: EventForm[], timezone: string, filterOutNotEditableKey = false): string => {
  // console.log('toIcsString', { events, timezone });
  const str = '';
  const newEvents = [];

  if (events.length === 0) return str;

  for (let i = 0; i < events.length; i++) {
    const { fieldDictionary } = events[i];
    const event = {
      uid: events[i].id,
      startDate: events[i].start,
      startTimezone: events[i].startTimezone,
      start: convertTimestampToArray(events[i].start),
      title: events[i].title,
      description: events[i].description ?? '',
      endTimezone: events[i].endTimezone,
      endDate: events[i].end,
      end: convertTimestampToArray(events[i].end),
      recurrenceRule: events[i].recurrenceRule ? events[i].recurrenceRule.replace('RRULE:', '') : '',
      categories: events[i].categories ?? [],
      location: events[i].location ?? '',
      startOutputType: 'local',
      endOutputType: 'local',
      timezone: events[i].timezone,
      exdate: events[i].exdate,
      attachedFuelEntityType: events[i].attachedFuelEntityType ? events[i].attachedFuelEntityType : '',
      attachedFuelEntityId: events[i].attachedFuelEntityId ? events[i].attachedFuelEntityId : '',
      attachedFuelDisplayClassName: events[i].attachedFuelDisplayClassName ? events[i].attachedFuelDisplayClassName : '',
      attachedFuelEventFlags: events[i].attchedFuelEventFlags ? events[i].attchedFuelEventFlags : '',
      attachedFuelGraphicsConfig: events[i].attachedFuelGraphicsConfig ? events[i].attachedFuelGraphicsConfig : '',
      // attachedFuelCustomAttributes:events[i].attachedFuelCustomAttributes ? events[i].attachedFuelCustomAttributes : ''
      fieldDictionary: events[i].fieldDictionary,
      subTitle: events[i].subTitle ? events[i].subTitle : '',
    };

    // // Create a new customAttributes with keys where values in metadata  fields are editable
    const { customAttributes } = events[i];
    const newObject = Object.keys(fieldDictionary)
      .filter((key) => fieldDictionary[key] && key in customAttributes) // Filter keys where the value is true
      .reduce((acc, key) => {
        acc[key] = customAttributes[key]; // Add the key-value pair to the new object
        return acc;
      }, {});

    if (!clientUtils.isObjectEmpty(newObject)) {
      const encodedCustomeAttributesJSON = compressionUtils.base64Encode(JSON.stringify(newObject));
      event.attachedFuelCustomAttributes = encodedCustomeAttributesJSON;
    }
    // console.log('event', event)
    newEvents.push(event);
  }

  let result = createEvents(newEvents);

  // console.log('toIcsString result', result);

  if (result && result.error) {
    return str;
  }

  result = applyVTimezones(timezone, events, result);

  const icsString = calendarUtils.cleanseICSString(result.value);
  // icsString = icsString.replace(/DTSTART:/g, `DTSTART;TZID="${timezone}":`).replace(/DTEND:/g, `DTEND;TZID="${timezone}":`);
  return icsString;
};

export const applyVTimezones = (timezone: string, events: EventForm[], result: ReturnResult) => {
  // console.log('applyVTimezones', timezone, events, result);

  let allTimezones: string[] = [];
  allTimezones.push(timezone);
  for (let i = 0; i < events.length; i++) {
    allTimezones.push(events[i].startTimezone);
    allTimezones.push(events[i].endTimezone);
  }

  allTimezones = _.uniq(allTimezones);

  // console.log('alallTimezonesl', { allTimezones });

  if (events.length > 0 && allTimezones.length > 0) {
    let newValue = result.value;
    let allBlocks = '';

    for (let i = 0; i < allTimezones.length; i++) {
      const tz = allTimezones[i];
      const tzBlock = tzlib_get_ical_block(tz);
      // console.log('loop', i, tz, ' -> ', tzBlock);
      if (tzBlock && tzBlock.length > 0) {
        allBlocks += `${tzBlock[0]}\r\n`;
        newValue = newValue.replace(new RegExp(`TZID=${tz}`, 'g'), tzBlock[1]);
      }
    }
    const position = newValue.indexOf('BEGIN:VEVENT');
    newValue = [newValue.slice(0, position), allBlocks, newValue.slice(position)].join('');
    // console.log(newValue);
    result.value = newValue;
  }

  return result;
};

export const getDateTimeArray = (date: Date, timezone) => {
  // const newDate = new Date(date);
  // console.log(date)
  return [date.getFullYear(), date.getMonth() + 1, date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()];
};

export const diff_minutes = (dt2, dt1) => {
  let diff = (dt2.getTime() - dt1.getTime()) / 1000;
  diff /= 60;
  return Math.abs(Math.round(diff));
};
